/* eslint-disable */

import successIcon from '../assets/images/proof_of_record_success.svg'
import InComplete from '../assets/images/proof_of_record_incomplete.svg'
import Pending from '../assets/images/proof_of_record_pending.svg'
import Loading from '../assets/images/proof_of_record_loading.svg'
import HubIcon from '../assets/images/hub-icon.svg'
import MyFilesIcon from '../assets/images/myFilesIcon.svg'
import MyFilesIconPurp from '../assets/images/file-icon-purple.svg'
import HubIconPurp from '../assets/images/hubs-ico.svg'
import documentationIcon from '../assets/images/documents-icon-new.svg'
import documentationIconPurp from '../assets/images/doc-icon-purple.svg'
import settingsIcon from '../assets/images/settings-icon-new.svg'
import settingsIconPurp from '../assets/images/settings-icon-purple.svg'
import fileLogUploadIcon from '../assets/images/uploaded.svg'
import fileLogBlockchainIcon from '../assets/images/blockchain_Indexed.svg'
import fileLogViewedIcon from '../assets/images/viewed.svg'
import fileLogDownloadedIcon from '../assets/images/downloaded.svg'
import folderCreateLog from '../assets/images/folder-create-icon.svg'
import fileLogSignedIcon from '../assets/images/signatured.svg'
import fileLogStabilityIcon from '../assets/images/stabillity.svg'
import fileLogBsvIcon from '../assets/images/Bsv.svg'
import fileLogWatermarkedIcon from '../assets/images/watermarked_icon.svg'
import fileLogSavedIcon from '../assets/images/saved_icon.svg'
import fileLogSharedIcon from '../assets/images/shared_icon.svg'
import fileLogRenamedIcon from '../assets/images/renamed_icon.svg'
import fileLogDeletedIcon from '../assets/images/deleted_icon.svg'
import fileLogRestoredIcon from '../assets/images/restored.svg'
import fileLogSecurityIcon from '../assets/images/security_icon.svg'
import fileLogTagIcon from '../assets/images/tagged_icon.svg'
import fileLogDefaultIcon from '../assets/images/default-activity-logo.svg'
import blockchainIco from '../assets/images/blockchain_ico.svg'

export interface ISidebarItems {
  title: string
  icon: string
  icon_purp?: string
  href: string
  id: string
}

export type securityConstantsType = {
  name: string
  value: string
}
export type holdingPiiConstantsType = {
  name: string
  value: boolean | null
}
export const securityConstants: securityConstantsType[] = [
  { name: 'Default', value: 'DEFAULT_LEVEL' },
  { name: 'Sensitive', value: 'SENSITIVE_LEVEL' },
  // { name: 'Top Secret', value: 'TOP_SECRET_LEVEL' },
]

export const holdingPiiConstants: holdingPiiConstantsType[] = [
  { name: 'All files', value: null },
  { name: 'Files containing PII', value: true },
  { name: 'Files with no PII', value: false },
]

export const securityConstantsMap = {
  DEFAULT_LEVEL: 'defaultSecurity',
  SENSITIVE_LEVEL: 'sensitive',
  TOP_SECRET_LEVEL: 'topSecret',
}

export default {
  securityConstants,
}

export const modalStyle = {
  display: 'flex',
  flexDirection: 'column',
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { xs: '90vw', sm: '65rem', lg: '80rem' },
  bgcolor: 'modalBackground.main',
  p: '1.6rem',
  paddingRight: '0',
  paddingBottom: '1rem',
  gap: '3rem',
  borderRadius: '4px',
  boxShadow:
    ' 0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12)',
}

export const splitFileName = (
  name: string,
  mimeType?: string | null
): { base: string; extension: string } => {
  if (!name) {
    return { base: '', extension: '' }
  }

  const lastDotIndex = name.lastIndexOf('.')
  if (lastDotIndex <= 0 || lastDotIndex >= name.length - 1) {
    return { base: name, extension: '' }
  }

  const extension = name.slice(lastDotIndex)

  if (mimeType) {
    const normalizedMime = mimeType.toLowerCase()
    const expectedExtension = MIME_EXTENSION_MAP[normalizedMime]

    if (expectedExtension && expectedExtension.toLowerCase() !== extension.toLowerCase()) {
      return { base: name, extension: '' }
    }
  }

  return {
    base: name.slice(0, lastDotIndex),
    extension,
  }
}

export const MIME_EXTENSION_MAP: Record<string, string> = {
  'application/pdf': '.pdf',
  'text/plain': '.txt',
  'text/csv': '.csv',
  'text/tab-separated-values': '.tsv',
  'application/msword': '.doc',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': '.docx',
  'application/vnd.ms-excel': '.xls',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': '.xlsx',
  'application/vnd.ms-excel.sheet.macroenabled.12': '.xlsm',
  'application/vnd.ms-excel.sheet.binary.macroenabled.12': '.xlsb',
  'application/vnd.ms-excel.template.macroenabled.12': '.xltm',
  'application/vnd.ms-powerpoint': '.ppt',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': '.pptx',
  'application/json': '.json',
  'application/zip': '.zip',
  'application/x-7z-compressed': '.7z',
  'application/x-rar-compressed': '.rar',
  'image/png': '.png',
  'image/jpeg': '.jpg',
  'image/gif': '.gif',
  'image/bmp': '.bmp',
  'image/webp': '.webp',
  'image/heic': '.heic',
  'image/heif': '.heif',
  'image/tiff': '.tiff',
  'audio/mpeg': '.mp3',
  'audio/wav': '.wav',
  'audio/aac': '.aac',
  'audio/flac': '.flac',
  'audio/ogg': '.ogg',
  'audio/webm': '.webm',
  'audio/vorbis': '.oga',
  'audio/x-m4a': '.m4a',
  'video/mp4': '.mp4',
  'video/mpeg': '.mpg',
  'video/x-msvideo': '.avi',
  'video/quicktime': '.mov',
  'video/webm': '.webm',
  'video/x-matroska': '.mkv',
  'application/x-matroska': '.mkv',
  'application/ogg': '.ogg',
  'video/avi': '.avi',
  'video/x-flv': '.flv',
  'video/ogg': '.ogv',
}

const audioMimeEntries = Object.entries(MIME_EXTENSION_MAP).filter(([mimeType]) =>
  mimeType.startsWith('audio/')
)

export const audioMimeTypes = new Set<string>(audioMimeEntries.map(([mimeType]) => mimeType))

export const audioExtensions = new Set<string>(
  audioMimeEntries.map(([, extension]) => extension.toLowerCase())
)

export const isAudioMimeType = (mimeType?: string | null): boolean =>
  Boolean(mimeType && audioMimeTypes.has(mimeType))

export const isAudioExtension = (extension?: string | null): boolean =>
  Boolean(extension && audioExtensions.has(extension.toLowerCase()))

export const audioExtensionToMimeType = audioMimeEntries.reduce<Record<string, string>>(
  (acc, [mimeType, extension]) => {
    acc[extension.toLowerCase()] = mimeType
    return acc
  },
  {}
)

const baseVideoEntries = Object.entries(MIME_EXTENSION_MAP).filter(([mimeType]) =>
  mimeType.includes('video')
)

const imageMimeEntries = Object.entries(MIME_EXTENSION_MAP).filter(([mimeType]) =>
  mimeType.startsWith('image/')
)

export const imageMimeTypes = new Set<string>(imageMimeEntries.map(([mimeType]) => mimeType))

export const isImageMimeType = (mimeType?: string | null): boolean =>
  Boolean(mimeType && imageMimeTypes.has(mimeType))

const baseVideoExtensions = new Set<string>(
  baseVideoEntries.map(([, extension]) => extension.toLowerCase())
)

const videoExtensionOverrides = ['.ogg']
videoExtensionOverrides.forEach(extension => baseVideoExtensions.add(extension))

const allVideoEntries = Object.entries(MIME_EXTENSION_MAP).filter(([mimeType, extension]) => {
  if (mimeType.includes('video')) {
    return true
  }

  return mimeType.startsWith('application/') && baseVideoExtensions.has(extension.toLowerCase())
})

export const videoMimeTypes = new Set<string>(allVideoEntries.map(([mimeType]) => mimeType))

export const videoExtensions = baseVideoExtensions

export const isVideoMimeType = (mimeType?: string | null): boolean =>
  Boolean(mimeType && videoMimeTypes.has(mimeType))

export const isVideoExtension = (extension?: string | null): boolean =>
  Boolean(extension && videoExtensions.has(extension.toLowerCase()))

const excelMimeEntries = Object.entries(MIME_EXTENSION_MAP).filter(
  ([mimeType]) =>
    mimeType.includes('excel') ||
    mimeType.includes('spreadsheetml') ||
    mimeType.includes('x-tika-ooxml') ||
    mimeType === 'application/zip'
)

export const excelMimeTypes = new Set<string>(excelMimeEntries.map(([mimeType]) => mimeType))

export const isExcelMimeType = (mimeType?: string | null): boolean =>
  Boolean(mimeType && excelMimeTypes.has(mimeType))

export enum logFileTypes {
  RENAME = 'Rename',
  SECURITY_LEVEL_CHANGE = 'Security level',
  DOWNLOAD = 'Download',
  UPLOAD = 'Upload',
  SHARE = 'Share',
  BLOCKCHAIN = 'Blockchain',
  VIEWED = 'Viewed',
}

export enum logFileTypeColors {
  RENAME = 'warning.main',
  SECURITY_LEVEL_CHANGE = 'error.main',
  DOWNLOAD = 'text.primary',
  UPLOAD = 'success.main',
  SHARE = 'info.main',
  BLOCKCHAIN = 'info.main',
  VIEWED = 'info.main',
}

export const signatureLocations = [
  { name: 'Top left', value: 'topleft' },
  { name: 'Top center', value: 'topcenter' },
  { name: 'Top right', value: 'topright' },

  { name: 'Center left', value: 'centerleft' },
  { name: 'Center', value: 'center' },
  { name: 'Center right', value: 'centerright' },

  { name: 'Bottom left', value: 'bottomleft' },
  { name: 'Bottom center', value: 'bottomcenter' },
  { name: 'Bottom right', value: 'bottomright' },
]

export enum signaturePosition {
  topleft = 'topleft',
  topcenter = 'topcenter',
  topright = 'topright',
  centerleft = 'centerleft',
  center = 'center',
  centerright = 'centerright',
  bottomleft = 'bottomleft',
  bottomcenter = 'bottomcenter',
  bottomright = 'bottomright',
}

type blockchainChipStatus = {
  [key: string]: {
    label: string
    color: string
    icon: string
    borderColor: string
    loadingIcon?: string
  }
}

export const blockchainChipStatuses: blockchainChipStatus = {
  STORED: {
    label: 'Proof of Record',
    color: '#006F2B',
    icon: successIcon,
    borderColor: '#B1FFC4',
    loadingIcon: '',
  },
  PARTIAL: {
    label: 'Proof of Record Incomplete',
    color: '#995900',
    icon: InComplete,
    borderColor: '#FFDFB3',
    loadingIcon: '',
  },
  PENDING: {
    label: 'Proof of Record Pending',
    color: '#3C4A5A',
    icon: Pending,
    borderColor: '#D6E0EB',
    loadingIcon: Loading,
  },
  NOT_STARTED: {
    label: 'Proof of Record Incomplete',
    color: '#995900',
    icon: InComplete,
    borderColor: '#FFDFB3',
    loadingIcon: '',
  },
  ERROR: {
    label: 'Proof of Record Incomplete',
    color: '#995900',
    icon: InComplete,
    borderColor: '#FFDFB3',
    loadingIcon: '',
  },
}

export enum fileSecurityLevels {
  DEFAULT_LEVEL = 'DEFAULT_LEVEL',
  SENSITIVE_LEVEL = 'SENSITIVE_LEVEL',
  TOP_SECRET_LEVEL = 'TOP_SECRET_LEVEL',
}

export interface CityOption {
  name: string
  value: string
}

export interface RegionData {
  name: string
  value: string
  cities: CityOption[]
}

export const regionData: RegionData[] = [
  {
    name: 'China',
    value: 'china',
    cities: [
      { name: 'Nanjing', value: 'nanjing' }, // Not in region list, kept as-is
      { name: 'Guangzhou', value: 'ap-guangzhou' },
      { name: 'Chengdu', value: 'ap-chengdu' },
      { name: 'Hongkong (China)', value: 'ap-hongkong' },
      { name: 'Beijing', value: 'ap-beijing' },
      { name: 'Shanghai', value: 'ap-shanghai' },
      { name: 'Chingqing', value: 'ap-chongqing' }, // Assuming typo for "Chongqing"
    ],
  },
  {
    name: 'Asia Pacific',
    value: 'asia_pacific',
    cities: [
      { name: 'Singapore', value: 'ap-singapore' },
      { name: 'Seoul, South Korea', value: 'ap-seoul' },
      { name: 'Bangkok, Thailand', value: 'ap-bangkok' },
      { name: 'Tokyo, Japan', value: 'ap-tokyo' },
      { name: 'Jakarta, Indonesia', value: 'jakarta_indonesia' }, // Not in list, kept as-is
    ],
  },
  {
    name: 'Europe',
    value: 'europe',
    cities: [{ name: 'Frankfurt, Germany', value: 'eu-frankfurt' }],
  },
  {
    name: 'North America',
    value: 'north_america',
    cities: [
      { name: 'Ashburn, United States', value: 'na-ashburn' },
      { name: 'Silicon Valley, United States', value: 'na-siliconvalley' },
    ],
  },
  {
    name: 'South America',
    value: 'south_america',
    cities: [{ name: 'Sao Paulo, Brazil', value: 'sa-saopaulo' }],
  },
  {
    name: 'Financial zone',
    value: 'financial_zone',
    cities: [
      { name: 'Shenzhen finance', value: 'ap-guangzhou-open' }, // Closest match for Shenzhen finance zone
      { name: 'Shanghai finance', value: 'ap-shanghai-fsi' },
      { name: 'Beijing finance', value: 'ap-beijing-fsi' },
    ],
  },
]

// Static region options
export const validRegions = [
  { value: 'eu-west-1', name: 'Europe (Ireland)' },
  { value: 'eu-west-2', name: 'Europe (London)' },
  { value: 'eu-west-3', name: 'Europe (Paris)' },
  { value: 'eu-central-1', name: 'Europe (Frankfurt)' },
  { value: 'eu-north-1', name: 'Europe (Stockholm)' },
  { value: 'eu-south-1', name: 'Europe (Milan)' },
  { value: 'eu-south-2', name: 'Europe (Spain)' },
  { value: 'eu-central-2', name: 'Europe (Zurich)' },
  { value: 'ap-east-1', name: 'Asia Pacific (Hong Kong)' },
  { value: 'ap-east-2', name: 'Asia Pacific (Taipei)' },
  { value: 'ap-south-1', name: 'Asia Pacific (Mumbai)' },
  { value: 'ap-south-2', name: 'Asia Pacific (Hyderabad)' },
  { value: 'ap-southeast-1', name: 'Asia Pacific (Singapore)' },
  { value: 'ap-southeast-2', name: 'Asia Pacific (Sydney)' },
  { value: 'ap-southeast-3', name: 'Asia Pacific (Jakarta)' },
  { value: 'ap-southeast-4', name: 'Asia Pacific (Melbourne)' },
  { value: 'ap-southeast-5', name: 'Asia Pacific (Malaysia)' },
  { value: 'ap-southeast-7', name: 'Asia Pacific (Thailand)' },
  { value: 'ap-northeast-1', name: 'Asia Pacific (Tokyo)' },
  { value: 'ap-northeast-2', name: 'Asia Pacific (Seoul)' },
  { value: 'ap-northeast-3', name: 'Asia Pacific (Osaka)' },
  { value: 'sa-east-1', name: 'South America (São Paulo)' },
  { value: 'ca-central-1', name: 'Canada (Central)' },
  { value: 'ca-west-1', name: 'Canada West (Calgary)' },
  { value: 'me-south-1', name: 'Middle East (Bahrain)' },
  { value: 'me-central-1', name: 'Middle East (UAE)' },
  { value: 'af-south-1', name: 'Africa (Cape Town)' },
  { value: 'il-central-1', name: 'Israel (Tel Aviv)' },
  { value: 'mx-central-1', name: 'Mexico (Central)' },
  { value: 'us-east-1', name: 'US East (N. Virginia)' },
  { value: 'us-east-2', name: 'US East (Ohio)' },
  { value: 'us-west-1', name: 'US West (N. California)' },
  { value: 'us-west-2', name: 'US West (Oregon)' },
]

export const hetznerRegions = [
  { value: 'hel1', name: 'EU (Finland)' },
  { value: 'fsn1', name: 'EU (Falkenstein)' },
  { value: 'nbg1', name: 'EU (Nuremberg)' },
]

export const OVHRegions = [
  { value: 'de', name: 'Frankfurt (DE)' },
  { value: 'uk', name: 'London (UK)' },
  { value: 'bhs', name: 'Beauharnois (BHS)' },
  { value: 'gra', name: 'Gravelines (GRA)' },
  { value: 'sbg', name: 'Strasbourg (SBG)' },
  { value: 'spg', name: 'Singapore (SBG)' },
  { value: 'waw', name: 'Warsaw (WAW)' },
  { value: 'ap-south-mum', name: 'Mumbai (AP-SOUTH-MUM)' },
  { value: 'ap-south-syd', name: 'Sydney (AP-SOUTHEAST-SYD)' },
  { value: 'ca-east-tor', name: 'Toronto (CA-EAST-TOR)' },
  { value: 'rbx', name: 'Roubaix (RBX)' },
]

export const OCIRegions = [
  // Africa
  { value: 'af-johannesburg-1', name: 'Johannesburg (Africa South)' },

  // Asia-Pacific
  { value: 'ap-batam-1', name: 'Batam (AP Southeast)' },
  { value: 'ap-chennai-1', name: 'Chennai (AP South)' },
  { value: 'ap-chuncheon-1', name: 'Chuncheon (AP Northeast)' },
  { value: 'ap-delhi-1', name: 'Delhi (AP South)' },
  { value: 'ap-hyderabad-1', name: 'Hyderabad (AP South)' },
  { value: 'ap-kulai-1', name: 'Kulai (AP Southeast)' },
  { value: 'ap-melbourne-1', name: 'Melbourne (AP Southeast)' },
  { value: 'ap-mumbai-1', name: 'Mumbai (AP South)' },
  { value: 'ap-osaka-1', name: 'Osaka (AP East)' },
  { value: 'ap-seoul-1', name: 'Seoul (AP Northeast)' },
  { value: 'ap-singapore-1', name: 'Singapore (AP Southeast)' },
  { value: 'ap-singapore-2', name: 'Singapore Secondary (AP Southeast)' },
  { value: 'ap-sydney-1', name: 'Sydney (AP Southeast)' },
  { value: 'ap-tokyo-1', name: 'Tokyo (AP East)' },

  // Europe
  { value: 'eu-amsterdam-1', name: 'Amsterdam (EU West)' },
  { value: 'eu-dublin-3', name: 'Dublin (EU West)' },
  { value: 'eu-frankfurt-1', name: 'Frankfurt (EU Central)' },
  { value: 'eu-kragujevac-1', name: 'Kragujevac (EU South)' },
  { value: 'eu-madrid-1', name: 'Madrid (EU South)' },
  { value: 'eu-madrid-3', name: 'Madrid Additional (EU South)' },
  { value: 'eu-marseille-1', name: 'Marseille (EU South)' },
  { value: 'eu-milan-1', name: 'Milan (EU South)' },
  { value: 'eu-paris-1', name: 'Paris (EU West)' },
  { value: 'eu-stockholm-1', name: 'Stockholm (EU North)' },
  { value: 'eu-turin-1', name: 'Turin (EU South)' },
  { value: 'eu-zurich-1', name: 'Zurich (EU Central)' },

  // Middle East
  { value: 'me-abudhabi-1', name: 'Abu Dhabi (ME Central)' },
  { value: 'me-dubai-1', name: 'Dubai (ME East)' },
  { value: 'me-jeddah-1', name: 'Jeddah (ME West)' },
  { value: 'me-neom-1', name: 'Neom (ME Central)' },
  { value: 'me-riyadh-1', name: 'Riyadh (ME Central)' },
  { value: 'il-jerusalem-1', name: 'Jerusalem (ME West)' },

  // North America (USA)
  { value: 'us-abilene-1', name: 'Abilene (US Central)' },
  { value: 'us-ashburn-1', name: 'Ashburn (US East)' },
  { value: 'us-boardman-1', name: 'Boardman (US West)' },
  { value: 'us-chicago-1', name: 'Chicago (US Central)' },
  { value: 'us-dallas-1', name: 'Dallas (US Central)' },
  { value: 'us-desmoines-1', name: 'Des Moines (US Central)' },
  { value: 'us-phoenix-1', name: 'Phoenix (US West)' },
  { value: 'us-quincy-1', name: 'Quincy (US West)' },
  { value: 'us-saltlake-1', name: 'Salt Lake City Primary (US West)' },
  { value: 'us-saltlake-2', name: 'Salt Lake City Secondary (US West)' },
  { value: 'us-sanjose-1', name: 'San Jose (US West)' },
  { value: 'us-shawnee-1', name: 'Shawnee (US Central)' },
  { value: 'us-tukwila-4', name: 'Tukwila (US West)' },

  // Canada
  { value: 'ca-montreal-1', name: 'Montreal (CA East)' },
  { value: 'ca-toronto-1', name: 'Toronto (CA East)' },

  // Latin America
  { value: 'sa-bogota-1', name: 'Bogota (SA North)' },
  { value: 'sa-riodejaneiro-2', name: 'Rio de Janeiro (SA East)' },
  { value: 'sa-santiago-1', name: 'Santiago (SA South)' },
  { value: 'sa-saopaulo-1', name: 'São Paulo (SA South)' },
  { value: 'sa-valparaiso-1', name: 'Valparaiso (SA South)' },
  { value: 'sa-vinhedo-1', name: 'Vinhedo (SA South)' },
  { value: 'mx-monterrey-1', name: 'Monterrey (MX North)' },
  { value: 'mx-queretaro-1', name: 'Queretaro (MX Central)' },
]

export const hubFeatures = [
  'Custom Hubs: Create and name hubs for departments like “Marketing”',
  'Flexible Rooms: Add rooms for file collaboration.',
  'Open Access: Share files with all room members, any organization.',
  'Collaborative Uploads: Members can add files and folders.',
  'Organised: Manage files and folders easily.',
  'Activity Log: All changes are logged and indexed to blockchain.',
]

export const baseSidebarItems: ISidebarItems[] = [
  {
    title: 'Files',
    icon: MyFilesIcon,
    icon_purp: MyFilesIconPurp,
    href: '/files',
    id: 'myFilesLink',
  },
]

export const supportItems: ISidebarItems[] = [
  {
    title: 'Documentation',
    icon: documentationIcon,
    icon_purp: documentationIconPurp,
    href: '/documentation',
    id: 'documentationLink',
  },
  {
    title: 'Settings',
    icon: settingsIcon,
    icon_purp: settingsIconPurp,
    href: '/manage',
    id: 'settingsLink',
  },
]

export const collaborationItems: ISidebarItems[] = [
  {
    title: 'Hubs',
    icon: HubIconPurp,
    icon_purp: HubIcon,
    href: '/hub',
    id: 'hubLink',
  },
]

/* ---------------------- Chatbox Styles ---------------------- */
export const styles = {
  allMembersChip: {
    display: 'flex',
    margin: 'auto',
    padding: '8px',
    alignItems: 'center',
    gap: '8px',
    borderRadius: '6px',
    background: '#F8F3FF',
    color: '#1F2B37',
    fontFamily: 'Geist',
    fontSize: '13px',
    fontWeight: 500,
    lineHeight: '20px',
    width: '222px',
    mt: 2.5,
    mb: 2.5,
  },
  chatHeader: {
    borderBottom: '1px solid #E5EBF2',
    height: '69px',
    px: '24px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  searchField: {
    backgroundColor: '#f4f1f8',
    width: 260,
    borderRadius: '8px',
    pl: 1,
    '& input': {
      padding: '6px 4px',
      fontSize: '14px',
      width: '180px',
      fontFamily: 'Geist',
    },
    '& input::placeholder': {
      color: '#11072F',
      fontFamily: 'Geist',
      fontSize: '12px',
      fontWeight: 400,
      lineHeight: '24px',
    },
  },
  filterButton: {
    display: 'flex',
    height: 32,
    px: 2,
    alignItems: 'center',
    gap: 1,
    borderRadius: '5px',
    border: '1px solid #D4D4DC',
    cursor: 'pointer',
    color: '#11072F',
    fontFamily: 'Geist',
    fontSize: '12px',
    fontWeight: 500,
    width: '86px',
  },
  chatBody: {
    background: '#F6F8FC',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  centerMessage: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#1F2B37',
    textAlign: 'center',
    fontFamily: 'Geist',
    fontSize: '15px',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '-0.3px',
  },
  subText: {
    color: '#7A8897',
    fontFamily: 'Geist',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '18px',
    mt: '4px',
  },
}

export const MSAL_ERROR_MESSAGES: Record<string, string> = {
  login_required: 'Your session has expired. Please login again.',
  interaction_required: 'Additional interaction is required to sign in. Please try again.',
  invalid_grant: 'Invalid credentials. Please check your account and try again.',
  user_cancelled: 'Login was cancelled. Please try again.',
  client_mismatch: 'There was an issue with your application configuration.',
  network_error: 'A network error occurred. Please check your connection.',
  unknown_error: 'An unexpected error occurred. Please try again later.',
}

export const FILE_LOG_DEFAULT_ACTION_LABEL = 'Activity'

export const FILE_LOG_ACTION_TITLE_MAP: Record<string, string> = {
  UPLOAD: 'Uploaded',
  CREATE: 'Created',
  BLOCKCHAIN: 'Blockchain Indexed',
  VIEWED: 'Viewed',
  DOWNLOAD: 'Downloaded',
  SIGNATURE: 'Signed',
  SIGN: 'Signed',
  WATERMARK: 'Watermarked',
  SAVE_FILE: 'Saved',
  SHARED: 'Shared',
  SHARE: 'Shared',
  RENAME: 'Renamed',
  RENAMED: 'Renamed',
  SOFT_DELETE: 'Soft Deleted',
  DELETED: 'Deleted',
  RESTORE: 'Restored',
  RESTORED: 'Restored',
  SECURITY_LEVEL_CHANGE: 'Security Level Changed',
  SECURITY_LEVEL_CHANGED: 'Security Level Changed',
  TAGGED_REMOVED: 'Tagged Removed',
  TAG_REMOVED: 'Tagged Removed',
  TAGGED_ADDED: 'Tagged Added',
  TAG_ADDED: 'Tagged Added',
  DEFAULT: 'Default',
}

export type FileLogActionStyle = {
  bg: string
  icon: string
  alt: string
}

export const FILE_LOG_DEFAULT_ACTION_STYLE: FileLogActionStyle = {
  bg: '#E5E7EB',
  icon: fileLogDefaultIcon,
  alt: 'Activity Icon',
}

export const FILE_LOG_ACTION_STYLE_MAP: Record<string, FileLogActionStyle> = {
  UPLOAD: {
    bg: '#DCFCE7',
    icon: fileLogUploadIcon,
    alt: 'Upload Icon',
  },
  CREATE: {
    bg: '#DCFCE7',
    icon: folderCreateLog,
    alt: 'Create Icon',
  },

  BLOCKCHAIN: {
    bg: '#DBEAFE',
    icon: fileLogBlockchainIcon,
    alt: 'Blockchain Icon',
  },
  VIEWED: {
    bg: '#FFE9D7',
    icon: fileLogViewedIcon,
    alt: 'Viewed Icon',
  },
  DOWNLOAD: {
    bg: '#E9D5FF',
    icon: fileLogDownloadedIcon,
    alt: 'Downloaded Icon',
  },
  SIGNATURE: {
    bg: '#FCE7F3',
    icon: fileLogSignedIcon,
    alt: 'Signed Icon',
  },
  SIGN: {
    bg: '#FCE7F3',
    icon: fileLogSignedIcon,
    alt: 'Signed Icon',
  },
  WATERMARK: {
    bg: '#FCE7F3',
    icon: fileLogWatermarkedIcon,
    alt: 'Watermarked Icon',
  },
  SAVE_FILE: {
    bg: '#E9D5FF',
    icon: fileLogSavedIcon,
    alt: 'Saved Icon',
  },
  SHARED: {
    bg: '#FFE9D7',
    icon: fileLogSharedIcon,
    alt: 'Shared Icon',
  },
  SHARE: {
    bg: '#FFE9D7',
    icon: fileLogSharedIcon,
    alt: 'Shared Icon',
  },
  RENAME: {
    bg: '#FCE7F3',
    icon: fileLogRenamedIcon,
    alt: 'Renamed Icon',
  },
  RENAMED: {
    bg: '#FCE7F3',
    icon: fileLogRenamedIcon,
    alt: 'Renamed Icon',
  },
  SOFT_DELETE: {
    bg: '#FEE2E2',
    icon: fileLogDeletedIcon,
    alt: 'Soft Deleted Icon',
  },
  DELETED: {
    bg: '#FEE2E2',
    icon: fileLogDeletedIcon,
    alt: 'Deleted Icon',
  },
  RESTORE: {
    bg: '#DCFCE7',
    icon: fileLogRestoredIcon,
    alt: 'Restored Icon',
  },
  RESTORED: {
    bg: '#DCFCE7',
    icon: fileLogRestoredIcon,
    alt: 'Restored Icon',
  },
  SECURITY_LEVEL_CHANGE: {
    bg: '#DCFCE7',
    icon: fileLogSecurityIcon,
    alt: 'Security Level Changed Icon',
  },
  SECURITY_LEVEL_CHANGED: {
    bg: '#DCFCE7',
    icon: fileLogSecurityIcon,
    alt: 'Security Level Changed Icon',
  },
  TAG_UPDATE: {
    bg: '#DBEAFE',
    icon: fileLogTagIcon,
    alt: 'Tagged Updated Icon',
  },
  DEFAULT: {
    bg: '#E5E7EB',
    icon: fileLogDefaultIcon,
    alt: 'Default Activity Icon',
  },
}

export const FILE_LOG_STABILITY_ICON = fileLogStabilityIcon
export const FILE_LOG_BSV_ICON = fileLogBsvIcon
export const BLOCKCHAIN_ICON = blockchainIco

export const FILE_LOG_LABELS = {
  viewOnBlockchain: 'View on BlockChain',
  qrCode: 'QR Code',
}
